<h1>Sprite objects</h1>
<canvas #canvasDocument class="canvas"></canvas>
<div class="footer__fps">{{ fps }}</div>
<div class="footer__button-group">
  <p class="footer__label">Sprite collection type:</p>
  <button
    class="footer__button"
    *ngFor="let objectType of objectTypes"
    (tap)="selectObject(objectType)"
    [class.is-active]="selectedObjectType === objectType"
  >
    {{ objectType }}
  </button>
</div>
